<!-- 选择课程级联 -->
<template>
  <el-form-item :label="label">
    <yx-course-cascader
      @select="select"
      ref="child"
      @clear="clear"
      :queryParams="params"
      v-bind="config"
      width="222px"
    />
  </el-form-item>
</template>

<script>
import { inject, ref, onMounted } from 'vue';

export default {
  kind: 'yq-课程级联选择',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number, Object],
      default: () => ({}),
    },
    config: {
      type: Object,
      default() {
        return {};
      },
    },
    label: {
      type: String,
      default: '教学课程：',
    },
    params: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  setup(props) {
    const child = ref(null);
    const useQuery = inject('useQuery');

    function reset() {
      // eslint-disable-next-line no-use-before-define
      attendClassTeacher.value = props.value;
      if (props.value?.priceItem?.id) {
        const { course, priceItem } = props.value;
        child.value.setField(`[${course.curriculumName}]${priceItem.priceItemName}`);
      } else {
        child.value.clearField();
      }
    }

    const attendClassTeacher = useQuery('attendClassTeacher', props.value, reset);

    if (props.value?.priceItem?.id) {
      onMounted(() => {
        const { course, priceItem } = props.value;
        child.value.setField(`[${course.curriculumName}]${priceItem.priceItemName}`);
      });
    }

    function select(obj) {
      attendClassTeacher.value = obj;
    }

    return {
      reset,
      select,
      child,
      clear() {
        attendClassTeacher.value = {};
        child.value.clearField();
      },
    };
  },
};
</script>
